class BankLoginRMT {
  constructor ($rmt) {
    this.fintecsystems = new FintecsystemsRMT($rmt)
    this.schufa = new SchufaRMT($rmt)
  }
}

class Tracking {
  send () {
    this.trackEvent({ action: 'send' })
  }

  resend () {
    this.trackEvent({ action: 'resend' })
  }

  success () {
    this.trackEvent({ action: 'success' })
  }

  fail () {
    this.trackEvent({ action: 'fail' })
  }

  error (errorName) {
    this.trackEvent({ action: `error:${errorName}`, forceDeposit: false })
  }

  trackEvent (options) {
    this.$rmt.trackEvent({
      category: this.category,
      forceDeposit: true,
      ...options
    })
  }
}

class FintecsystemsRMT extends Tracking {
  constructor ($rmt) {
    super()
    this.category = 'fintecsystems'
    this.$rmt = $rmt
  }

  initAuth () {
    this.trackEvent({ action: 'init_authentication' })
  }

  selectBank (bank) {
    this.trackEvent({ action: 'select-option', description: `${bank.name} - ${bank.bic} - ${bank.code}` })
  }
}

class SchufaRMT extends Tracking {
  constructor ($rmt) {
    super()
    this.category = 'schufa'
    this.$rmt = $rmt
  }
}

export default BankLoginRMT



// WEBPACK FOOTER //
// ./src/plugins/regily-mt/banklogin/bankloginRMT.js